import { render, staticRenderFns } from "./fallbackNode.vue?vue&type=template&id=08dbed54&scoped=true&"
import script from "./fallbackNode.vue?vue&type=script&lang=js&"
export * from "./fallbackNode.vue?vue&type=script&lang=js&"
import style0 from "./fallbackNode.vue?vue&type=style&index=0&id=08dbed54&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dbed54",
  null
  
)

export default component.exports